import React from 'react'

function FooterTop() {
    return (
        <div className="container-fluid ">
            <div className="row  FooterTop">
                <div className="col-md-3">
                    <h4>Track Expense</h4>
                    <li>Security</li>
                    <li>Business</li>
                    <li>Privacy</li>
                </div>
                <div className="col-md-3">
                    <h4>COMPANY</h4>
                    <li>Careers</li>
                    <li>Get in touch</li>
                    <li>About</li>
                </div>
                <div className="col-md-3">
                    <h4>DOWNLOAD</h4>
                    <li>Mac/PC</li>
                </div>
                <div className="col-md-3">
                    <h4>HELP</h4>
                    <li>Help Center</li>
                    <li>Coronavirus</li>

                </div>
            </div>
        </div>
    )
}
export default FooterTop;